import * as React from "react";
const SvgRectangle = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 6H4V18H20V6ZM2 4V20H22V4H2Z", fill: "currentColor" }));
export default SvgRectangle;
